import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  Pagination,
  Table,
  TableData,
  TableDataTypes,
} from "src/app/shared/types";
import { CaptainRedeemService } from "src/app/captain-redeem-service";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";

@Component({
  selector: "app-captain-gem-transaction-details",
  templateUrl: "./captain-gem-transaction-details.component.html",
  styleUrls: ["./captain-gem-transaction-details.component.css"],
})
export class CaptainGemsTransactionDetails implements OnInit {
  @Input() captainId: string;
  @Input() captainDetailsToggleableHeaders: string[];
  @Output() toggleHeaders: EventEmitter<any> = new EventEmitter();

  captainGemTransactions: Table;

  dataLoaded = false;
  perPage = 10;
  pageNo = 0;
  previousPageIndex = 0;
  lastDebitRequestId = "";
  lastCreditRequestId = "";
  priorDebitRequestId = "";
  priorCreditRequestId = "";
  transactionTypes = ["credit", "debit"];
  transactionArray = [];
  currentTransactionArray = [];

  constructor(private redeemService: CaptainRedeemService) {}

  ngOnInit() {
    this.declareTable();
  }

  declareTable() {
    this.captainGemTransactions = new Table({
      toggleableHeaders: this.captainDetailsToggleableHeaders,
      headers: {
        OrderId: "Order Id",
        TransactionId: "Transaction Id",
        TransactionType: "Transaction Type",
        TransactionDate: "Transaction Date",
        GemCount: "Gem Count",
        RedeemType: "Reedeem Type",
        RedeemValue: "Redeem Value",
      },
      pagination: new Pagination(0, this.perPage, 200, [10], 0, true),
      selectedHeader: 12,
      defaultError: "No gem transactions found",
      onRefresh: () => {
        this.captainGemTransactions = null;
        this.ngOnInit();
      },
      data: [],
    });
    this.getGemTransactions();
  }

  getNextGemTransactions(transactionArray: any) {
    this.priorCreditRequestId = "";
    this.priorDebitRequestId = "";
    for (let i = 0; i < transactionArray.length; i++) {
      const { id, type } = transactionArray[i];
      if (type === "credit") {
        this.lastCreditRequestId = id;
      }
      if (type === "debit") {
        this.lastDebitRequestId = id;
      }
    }
  }

  async getGemTransactions() {
    const data = {
      filters: {
        type: this.transactionTypes,
      },
      meta: {
        count: this.perPage,
        lastDebitRequestId: this.lastDebitRequestId,
        lastCreditRequestId: this.lastCreditRequestId,
        priorDebitRequestId: this.priorDebitRequestId,
        priorCreditRequestId: this.priorCreditRequestId,
      },
    };
    this.dataLoaded = false;

    const startIdx = this.pageNo * this.perPage;
    const endIdx = startIdx + this.perPage;
    this.currentTransactionArray = this.transactionArray.slice(
      startIdx,
      endIdx
    );
    let reachedEnd = false;
    if (this.currentTransactionArray.length == 0) {
      const response = await this.redeemService.getCoinIncentivePassbookDetails(
        this.captainId,
        data
      );
      const responseArray = response && response.data && response.data.data;
      this.transactionArray.push(...responseArray);
      this.currentTransactionArray = responseArray;

      if (this.currentTransactionArray.length == 0) {
        reachedEnd = true;
      }
    }

    if (!reachedEnd) {
      this.setCaptainGemsTxnData();
    } else {
      this.dataLoaded = true;
      this.captainGemTransactions.pagination = new Pagination(
        this.pageNo - 1,
        this.perPage,
        this.transactionArray.length,
        [10],
        this.previousPageIndex - 1,
        true
      );
    }
  }

  dateString(epoch: number): string {
    return new Date(epoch * 1000).toLocaleString();
  }

  createTableData(
    value: string,
    className?: string,
    type?: TableDataTypes,
    flag = false,
    hoverData = null
  ) {
    return new TableData({
      data: value,
      type: type ? type : TableDataTypes.DATA,
      flag: flag,
      hoverData: hoverData,
      className: className
        ? className + " cursor-pointer"
        : "cursor-pointer whiteSpacePre",
    });
  }

  changeInHeader(header: string) {
    this.toggleHeaders.emit(header);
  }

  onPaginationChange(event: {
    perPage: number;
    pageNo: number;
    previousPageIndex: number;
  }) {
    this.perPage = event.perPage;
    this.pageNo = event.pageNo;
    this.previousPageIndex = event.previousPageIndex;

    if (this.pageNo < this.previousPageIndex) {
      const startIdx = this.pageNo * this.perPage;
      const endIdx = startIdx + this.perPage;
      this.currentTransactionArray = this.transactionArray.slice(
        startIdx,
        endIdx
      );
      this.setCaptainGemsTxnData();
    } else if (this.pageNo >= this.previousPageIndex) {
      this.getNextGemTransactions(this.currentTransactionArray);
      this.getGemTransactions();
    }
  }

  setCaptainGemsTxnData() {
    this.captainGemTransactions.data = this.currentTransactionArray.map(
      (transaction) => {
        return {
          OrderId: this.createTableData(
            transaction &&
              transaction.orderDetails &&
              transaction.orderDetails.id
          ),
          TransactionId: this.createTableData(transaction.id),
          TransactionType: this.createTableData(transaction.type),
          TransactionDate: this.createTableData(transaction.createdAt),
          GemCount: this.createTableData(transaction.coin),
          RedeemType: this.createTableData(transaction.rewardType),
          RedeemValue: this.createTableData(transaction.amount),
        };
      }
    );
    this.dataLoaded = true;
  }
}
